<template>
   <div>
   <div class="col-xs-12 col-md-12 wrapper-box">
   
  
     <div class="row ">
        <div class="col-sm-5 col-xs-12">
                <h3 style="margin-bottom:0px;">Accepting Cats or Dogs is required <span class="red-star" data-toggle="popover" data-trigger="hover" data-placement="top" data-container="body" data-content="Required to publish your profile">★</span></h3>
                 
                <li class="checkbox">
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.AcceptCats">
                             Accepts Cats</label>
                </li>
               <li class="checkbox">
                     <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.AcceptSmallDogs">
                             Accept Small Dogs</label>
                </li>
                <li class="checkbox">
                    <label class="h5">
                    <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.AcceptMediumDogs">
                             Accept Medium Dogs</label>
                </li>

                <li class="checkbox"> 
                    <label class="h5">
                             <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.AcceptLargeDogs">
                            Accept Large Dogs</label>
                </li>
             

                
                <br>
                <h4>Experience with Pets</h4>
                
                <li class="checkbox">
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.CanCPR">
                             Can provide basic CPR first aid</label>
                </li>

                <li class="checkbox">
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.CanOral">
                             Can administer Oral medication</label>
                </li>

                
                <li class="checkbox">
                    <label class="h5">
                            <input v-on:change="somethingChanged()" type="checkbox" v-model="sitterPetPrefs.CanInject">
                             Can provide injections if needed</label>
                </li>
                
                
            </div>
            <div class="col-sm-8 col-md-7 col-xs-12">
                 <h3 >My Experience with Pets</h3>
                <textarea rows="5" v-on:change="somethingChanged()" v-model="sitterPetPrefs.Experience" placeholder="i.e I had 2 dogs for 5 years back home"  class="form-control"></textarea>
            </div>
            <div class="col-sm-8 col-md-7 col-xs-12">
                 <h3 >My Restrictions and Conditions</h3>
                <textarea rows="5" v-on:change="somethingChanged()" v-model="sitterPetPrefs.Restrictions" placeholder="If you have any specific restrictions for Dogs or Cats that you accept, please mention them here"  class="form-control"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8 col-md-10 col-sm-12 col-xs-12">
                <br>
                <button class="btn-block btn btn-lg btn-success" @click="updateSitterPetPrefs()">{{saveChanges}}</button>
            
            </div>
            </div>
            </div>
            </div>
</template>

<script>
import Vue from 'vue'
import sitterApi from '../../../services/sitterApi'
import router from '../../../router'
import auth from '../../../auth'
import store from '../../../data/store'
import commonApi from '../../../services/commonApi'



export default {
    name: 'PetPrefs',
    data() {
        return {
            saveChanges: "Save Changes",
            editing: false,

        }
        
    },
 
    methods: {
        updateSitterPetPrefs: function () {
            var self = this
            if (self.sitterPetPrefs.AcceptCats == false &&  self.sitterPetPrefs.AcceptSmallDogs== false  && self.sitterPetPrefs.AcceptMediumDogs == false && self.sitterPetPrefs.AcceptLargeDogs== false  ){
                    swal("Something is missing", "Please accept at least cats or dogs to enable your profile","info")
                    return
            }
            self.saveChanges = "Saving.."
            sitterApi.updateSitterPetPrefs().then(function (){
                self.saveChanges = "Saved"
                self.editing = false
                self.$parent.updateProfileStatus()
                if (self.profileReadyComp==false)
                router.push({ path: '/sitter-profile-edit/servicerates'});
            }).fail(function (){
                self.saveChanges = "Failed to Save"
                self.editing = false
            })
        },
          somethingChanged: function(){
            this.editing=true
            this.saveChanges = "Changes Pending Save"
        }
    
        
    },
    created: function () {
        var self = this
        this.$ga.page(this.$router)
        if (!store.getters.authenticated && !localStorage.getItem('access_token')) {
            router.router.push({ path: '/login', query: { redirect: 'sitterprofile/petpreferences' } })
        }
    
        if (!store.getters.SitterPetPrefs){
            sitterApi.getSitterPetPrefs()
        }
      
    },
    computed: {
        sitterPetPrefs: function(){
            return store.getters.SitterPetPrefs
        },
        profileReadyComp: function(){
            return this.$parent.profileStatus.IsProfileReady
        }
      
    },
    

}

</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// PetPrefs.vue?6148494c